import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import { RegularSection } from '@/components/Layouts'
import { getImageData } from '@/utilites/getImageData'
import Image from 'next/image'
import { Divider } from '@mui/material'

interface Content {
    title?: string
    text?: string
    before?: string[]
    after?: string[]
}

interface ProjectHistory_2Props {
    content?: Content
    blockName?:string
}

const Index = (props: ProjectHistory_2Props) => {
    const { content = {} } = props
    const { title, text, before, after } = content
    const beforeImages = (before || []).map((item) => getImageData(item))
    const afterImages = (after || []).map((item) => getImageData(item))
    return (
        <RegularSection aria-label='S3_blogopen_2' >
            <Grid
                container
                spacing={4}
                sx={{ mt: 4 }}
            >
                <Grid size={12}>
                    <Typography variant='h1'>{title}</Typography>
                </Grid>
                <Grid size={12}>
                    <Typography
                        variant='body1'
                        sx={{ whiteSpace: 'pre-line' }}
                    >
                        {text}
                    </Typography>
                </Grid>
                <Grid size={12}>
                    <Typography variant='h3'>before</Typography>
                    <Divider />
                </Grid>
                {beforeImages.map((item, index) => (
                        item.src ? (
                            <Grid
                                size={{ xs: 12, md: 6, lg: 4 }}
                                key={'before-img' + index}
                            >
                                <Image
                                    src={item.src}
                                    alt={item.alt || 'before-image-' + index}
                                    width={670}
                                    height={360}
                                    style={{ objectFit: 'cover', width: '100%', height: 'auto' }}
                                />
                            </Grid>
                        ) : null
                    ))}

                <Grid size={12}>
                    <Typography variant='h3'>after</Typography>
                    <Divider />
                </Grid>

                {afterImages.map((item, index) => (
                        item.src ? (
                            <Grid
                                size={{ xs: 12, md: 6, lg: 4 }}
                                key={'after-img' + index}
                            >
                                <Image
                                    src={item.src}
                                    alt={item.alt || 'after-image-' + index}
                                    width={670}
                                    height={360}
                                    style={{ objectFit: 'cover', width: '100%', height: 'auto' }}
                                />
                            </Grid>
                        ) : null
                    ))}
            </Grid>
        </RegularSection>
    )
}

export default Index
